// src/lib/gpWebsites.js — GP firm websites, keyed by mandate_name — each
// verified 2026-09-16 (web search + a content fetch confirming the firm,
// not just a plausible-looking domain). No entry means no verified official
// site was found: Marta Capital (Boom's sponsor) and Robinson Food
// Group are both private/newly-formed entities with no public web presence
// found — left out rather than guessed. Shared by PortalMandates (tile
// view) and PortalMandateDetail (mandate-scoped detail page).
export const GP_WEBSITES = {
  'Brentwood Fund VII': 'https://www.brentwood.com',
  'Chain Reaction':     'https://chain-reaction.io',
  'JVP CV':             'https://jvpvc.com',
  'JVP Fund 12':        'https://jvpvc.com',
  'Merchant':           'https://www.merchantim.com',
  'ZT Motors':          'https://www.ztautogroup.com',
  'Remilk':             'https://www.remilk.com',
}

// Internal-CRM-only websites for pipeline mandates not yet LIVE (never shown
// in the portal). Audited 2026-10-07: each domain matches the company's own
// email domain in RGA correspondence, except St Dominique (site's legal
// entity "St. Dominique Capital LLC" matches the NDA/LPA in Drive). Vivo and
// Vanterra | Flightlease are held until someone confirms which company each is.
export const CRM_GP_WEBSITES = {
  ...GP_WEBSITES,
  'Delos':                   'https://delos.com',
  'Healthkois':              'https://healthkois.com',
  'Port City BPO Sri Lanka': 'https://www.portcitybpo.lk',
  'SpotIt':                  'https://www.spotitearly.com',
  'St Dominique':            'https://stdominiquecapital.com',
  'True Layer':              'https://truelayer.com',
  'Upway':                   'https://upway.co',
}
